__turbopack_context__.v({
  "fade-in": "NewsList-module-scss-module__f0ahFG__fade-in",
  "inner": "NewsList-module-scss-module__f0ahFG__inner",
  "landscape": "NewsList-module-scss-module__f0ahFG__landscape",
  "listItem": "NewsList-module-scss-module__f0ahFG__listItem",
  "root": "NewsList-module-scss-module__f0ahFG__root",
});
